export default Backbone.Model.extend({
  initialize: function () {
    this.set("vote_date", new Date(this.get("vote_date")));
  }
});